import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '../../ui/alert';

interface MaintenanceAlertProps {
  isEnabled: boolean;
}

export function MaintenanceAlert({ isEnabled }: MaintenanceAlertProps) {
  if (!isEnabled) return null;

  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Modo mantenimiento activado</AlertTitle>
      <AlertDescription>
        El sitio publico mostrara el mensaje de mantenimiento. Verifica cuidadosamente antes de continuar.
      </AlertDescription>
    </Alert>
  );
}
